import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import ReceptionLayout from 'src/layouts/reception';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const ReceptionNewPage = lazy(() => import('src/pages/shipping/reception/new'));
const ReceptionListPage = lazy(() => import('src/pages/shipping/reception/list'));
const ReceptionDetailsPage = lazy(() => import('src/pages/shipping/reception/details'));
const DistributionNewPage = lazy(() => import('src/pages/shipping/distribution/new'));
const DistributionListPage = lazy(() => import('src/pages/shipping/distribution/list'));
const DistributionDetailsPage = lazy(() => import('src/pages/shipping/distribution/details'));
const DistributorManifestListPage = lazy(
  () => import('src/pages/shipping/distributor-manifest/list')
);
const DistributorManifestDetailsPage = lazy(
  () => import('src/pages/shipping/distributor-manifest/details')
);

// ----------------------------------------------------------------------

export const receptionRoutes = [
  {
    path: 'reception',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingScreen />}>
          <ReceptionLayout>
            <Outlet />
          </ReceptionLayout>
        </Suspense>
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Navigate to="new" replace /> },
      { path: 'new', element: <ReceptionNewPage /> },
      { path: 'list', element: <ReceptionListPage /> },
      { path: ':id', element: <ReceptionDetailsPage /> },
      {
        path: 'distribution',
        children: [
          { index: true, element: <DistributionListPage /> },
          { path: 'list', element: <DistributionListPage /> },
          { path: 'new', element: <DistributionNewPage /> },
          { path: ':id', element: <DistributionDetailsPage /> },
        ],
      },
      {
        path: 'distributor-manifest',
        children: [
          { index: true, element: <DistributorManifestListPage /> },
          { path: 'list', element: <DistributorManifestListPage /> },
          { path: ':id', element: <DistributorManifestDetailsPage /> },
        ],
      },
    ],
  },
];
